import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'

import { firewallAPI } from 'api'
import ModalForm from 'components/ModalForm'
import AddOutputBlock from './AddOutputBlock'

import {
  Badge,
  BadgeText,
  Button,
  ButtonText,
  ButtonIcon,
  Box,
  FlatList,
  VStack,
  Text,
  AddIcon,
  TrashIcon,
  EditIcon
} from '@gluestack-ui/themed'

import { ListHeader, ListItem } from 'components/List'

const OutputBlockList = (props) => {
  let list = props.list || []
  let title = props.title || `Firewall Output BlockList:`

  let refModal = useRef(null)
  let editRef = useRef(null)
  const [editing, setEditing] = useState(null)

  const deleteListItem = (item) => {
    const done = (res) => {
      props.notifyChange('block')
    }

    firewallAPI.deleteOutputBlock(item).then(done)
  }

  const notifyChange = (t) => {
    refModal.current()
    if (props.notifyChange)
      props.notifyChange('block')
  }

  const notifyEditChange = (t) => {
    editRef.current && editRef.current()
    setEditing(null)
    if (props.notifyChange) props.notifyChange('block')
  }

  return (
    <VStack>
      <ModalForm title="Edit IP Block" modalRef={editRef}>
        <AddOutputBlock item={editing} notifyChange={notifyEditChange} />
      </ModalForm>

      <ListHeader
        title={title}
        description="Block the Router's outbound traffic to the internet"
      >
        <ModalForm
          title={`Add IP Block`}
          triggerText="Add IP Block"
          triggerProps={{
            sx: {
              display: 'flex'
            }
          }}
          modalRef={refModal}
        >
          <AddOutputBlock notifyChange={notifyChange} />
        </ModalForm>
      </ListHeader>

      <FlatList
        data={list}
        renderItem={({ item }) => (
          <ListItem>
            <Badge action="muted" variant="outline">
              <BadgeText>{item.Protocol}</BadgeText>
            </Badge>

            <Text>{item.SrcIP}</Text>
            <Text>{item.DstIP}</Text>

            <Text flex={1} color="$muted500" isTruncated>
              {item.Description}
            </Text>

            <Button
              variant="link"
              alignSelf="center"
              onPress={() => {
                setEditing(item)
                editRef.current && editRef.current()
              }}
            >
              <ButtonIcon as={EditIcon} color="$muted600" />
            </Button>

            <Button
              ml="$3"
              alignSelf="center"
              size="sm"
              action="negative"
              variant="link"
              onPress={() => deleteListItem(item)}
            >
              <ButtonIcon as={TrashIcon} color="$red700" />
            </Button>
          </ListItem>
        )}
        keyExtractor={(item) => `${item.Protocol}${item.SrcIP}${item.DstIP}`}
      />

      {!list.length ? (
        <Text
          bg="$backgroundCardLight"
          sx={{ _dark: { bg: '$backgroundCardDark' } }}
          p="$4"
          flexWrap="wrap"
        >
          Block SPR outbound traffic to the internet
        </Text>
      ) : null}

      <Button
        sx={{ '@md': { display: list.length ? 'none' : 'none' } }}
        action="primary"
        variant="solid"
        rounded="$none"
        onPress={() => refModal.current()}
      >
        <ButtonText>Add IP Block</ButtonText>
        <ButtonIcon as={AddIcon} />
      </Button>
    </VStack>
  )
}

OutputBlockList.propTypes = {
  notifyChange: PropTypes.func.isRequired
}

export default OutputBlockList
